import { Component } from 'react';
import Questions from './components/Questions';
import Products from './components/Products';
import UserInformation from './components/UserInformation';
import Interval from './components/Interval';
import Information from './components/Information';
import { createUser, getInformation, incompleteRegistration, updateSubscriptionApi } from './query';
import { BILLING_IDS } from './constants';
import Message from '../Message';
import MessageCustom from '../../components/MessageCustom';
import Loading from '../../components/Loading';
import { showMessage } from '../../helpers/showMessage';
import AddOns from './components/AddOns';
import EditCard from './components/EditCard';
import Cancelation from './components/Cancelation/Cancelation';
import CancelationByUnselectAll from './components/Cancelation/CancelationByUnselectAll';

class CustomRegistration extends Component {
    constructor(props) {
        super(props);

        this.onChangeProducts = this.onChangeProducts.bind(this);
        this.onChangeInterval = this.onChangeInterval.bind(this);
        this.onChangeCustomPlan = this.onChangeCustomPlan.bind(this);
        this.onChangeUserInfo = this.onChangeUserInfo.bind(this);
        this.onShowRegistration = this.onShowRegistration.bind(this);
        this.updatePrices = this.updatePrices.bind(this);
        this.createRequestBody = this.createRequestBody.bind(this);
        this.deleteMessage = this.deleteMessage.bind(this);
        this.addEmailToIncompleteRegistration = this.addEmailToIncompleteRegistration.bind(this);
        this.updateSubscription = this.updateSubscription.bind(this);
        this.updatePaymentMethodId = this.updatePaymentMethodId.bind(this);
        this.updateLastPrice = this.updateLastPrice.bind(this);
        this.updatePromoCodeInfo = this.updatePromoCodeInfo.bind(this);
        this.updateAddOns = this.updateAddOns.bind(this);
        this.checkDeactivatedOne = this.checkDeactivatedOne.bind(this);
        this.onOpenCancelConfirmationModal = this.onOpenCancelConfirmationModal.bind(this);
        this.onCloseCancelConfirmationModal = this.onCloseCancelConfirmationModal.bind(this);
        this.checkIsChanged = this.checkIsChanged.bind(this);
        this.deleteItemFromPriceIds = this.deleteItemFromPriceIds.bind(this);
        this.onApplyBundleDiscount = this.onApplyBundleDiscount.bind(this);
        this.maybeApplyBundleDiscount = this.maybeApplyBundleDiscount.bind(this);
        this.deletePromoCodeInfo = this.deletePromoCodeInfo.bind(this);
        this.changeMoodEvent = new Event('changeMoodEvent');

        this.urlParams = new URLSearchParams(window.location.search);
        this.body = document.getElementsByTagName('body')[0];

        this.email = this.urlParams.get('email') || '';
        this.products = this.urlParams.get('products') || '';
        this.domainsQuantity = this.urlParams.get('google_analytics_domains');
        this.google_analytics_domains = Number(this.domainsQuantity || 1);
        this.ai_tracking_prompts = Number(this.urlParams.get('ai_tracking_prompts') || 100);
        this.interval = this.urlParams.get('interval') || 'monthly';
        this.template = this.urlParams.get('template');
        this.isAiTemplate = this.template === 'ai';
        this.isFreeAiTemplate = this.template === 'free_one_month';

        const defaultMode = localStorage.getItem('dark-mode');

        this.isDark = JSON.parse(localStorage.getItem('dark-mode'));

        if (defaultMode === 'true') {
            this.body.classList.add('dark-mode');
        }

        if (this.email) {
            this.email = atob(this.email);
        }
        if (this.products) {
            this.products = this.products.split(',');
        }

        let products = {
            google_discover_analytics: !this.products
                ? true
                : this.products.includes('google_discover_analytics'),
            google_search_analytics: !this.products
                ? true
                : this.products.includes('google_search_analytics'),
            ai_tracking: !this.products ? false : this.products.includes('ai_tracking'),
            commerce: !this.products ? false : this.products.includes('commerce'),
            additional_seats_per_domain: false,
            additional_seats_count: 1,
            google_analytics_domains: Number(this.google_analytics_domains),
            // ai_tracking_prompts: this.ai_tracking_prompts,
            ai_tracking_prompts: Math.ceil(this.ai_tracking_prompts / 10) * 10,
        };

        if (this.isAiTemplate) {
            products = {
                google_discover_analytics:
                    this.products?.includes('google_discover_analytics') || false,
                google_search_analytics:
                    this.products?.includes('google_search_analytics') || false,
                ai_tracking: this.products?.includes('ai_tracking') || true,
                commerce: this.products?.includes('commerce') || false,
                additional_seats_per_domain: false,
                additional_seats_count: 1,
                google_analytics_domains: this.google_analytics_domains,
                ai_tracking_prompts:
                    Math.ceil((this.urlParams.get('ai_tracking_prompts') || 20) / 10) * 10,
            };
        }

        if (this.isFreeAiTemplate) {
            products = {
                google_discover_analytics: false,
                google_search_analytics: false,
                ai_tracking: true,
                commerce: false,
                additional_seats_per_domain: false,
                additional_seats_count: 1,
                google_analytics_domains: 0,
                ai_tracking_prompts: 100,
            };
        }

        this.state = {
            interval: this.interval,
            products,
            defaultProducts: null,
            custom_plan: {
                billing_3_month: false,
                billing_12_month: false,
            },
            userInfo: {
                name: '',
                email: this.email ?? '',
                organization: '',
                geo_location: '',
                password: '',
                promotion_code: '',
                payment_method_id: null,
            },
            showRegistration: false,
            information: null,
            billingInfo: {
                commerce: null,
                searchAnalytics: null,
                discoverAnalytics: null,
                ai_tracking: null,
                additional_seats: null,
                content_analysis: null,
            },
            priceIds: {},
            geo_locations: [],
            already_registered: false,
            already_registered_message: '',
            informationLoading: false,
            updateLoading: false,
            lastPrice: 0,
            promotion_code_info: null,
            addOns: {
                contentAnalysis: 0,
                additionalSeats: 0,
            },
            defaultInterval: null,
            defaultPromotionCode: null,
            isCancelConfirmationModalOpen: false,
            defaultPriceIds: [],
        };
    }

    onOpenCancelConfirmationModal() {
        this.setState({ isCancelConfirmationModalOpen: true });
    }

    onCloseCancelConfirmationModal() {
        this.setState({ isCancelConfirmationModalOpen: false });
    }

    updatePrices(key, data) {
        this.setState((prevState) => ({ priceIds: { ...prevState.priceIds, [key]: data } }));
    }

    updateLastPrice(price) {
        this.setState({ lastPrice: price });
    }

    async addEmailToIncompleteRegistration() {
        try {
            if (!this.email) return;
            const body = {
                email: this.email,
            };
            const response = await incompleteRegistration(body);
            const data = await response.json();
            if (data?.already_registered) {
                this.setState({
                    already_registered: true,
                    already_registered_message:
                        'This email already exists in our system. Please login using this email, or use another email to register.',
                });
            }
        } catch (err) {
            console.log('Error adding email to incomplete registration:', err);
        }
    }

    async componentDidMount() {
        try {
            document.dispatchEvent(this.changeMoodEvent);

            this.setState({ informationLoading: true });
            this.addEmailToIncompleteRegistration();

            const response = await getInformation();
            const data = await response.json();
            if (!response.ok) {
                showMessage(data.detail || 'Error fetching information.', 'error');
                this.setState({ informationLoading: false });
                return;
            }
            let info = {
                commerce: null,
                searchAnalytics: null,
                discoverAnalytics: null,
                ai_tracking: null,
                additional_seats: null,
                content_analysis: null,
            };

            const active_plans = data?.active_plans;
            const geo_locations = data?.geo_locations;
            if (active_plans?.length !== 0) {
                const commerceInfo = active_plans.find(
                    (item) => item.product_slug === BILLING_IDS.COMMERCE,
                );
                const customSearchAnalyticsInfo = active_plans.find(
                    (item) => item.product_slug === BILLING_IDS.SEARCH_ANALYTICS,
                );
                const customDiscoverAnalyticsInfo = active_plans.find(
                    (item) => item.product_slug === BILLING_IDS.DISCOVER_ANALYTICS,
                );
                const aiTrackingInfo = active_plans.find(
                    (item) => item.product_slug === BILLING_IDS.AI_TRACKING,
                );
                const additional_seats = active_plans.find(
                    (item) => item.product_slug === BILLING_IDS.ADDITIONAL_SEATS,
                );
                const contentAnalysis = active_plans.find(
                    (item) => item.product_slug === BILLING_IDS.CONTENT_ANALYSIS,
                );

                info = {
                    commerce: commerceInfo,
                    searchAnalytics: customSearchAnalyticsInfo,
                    discoverAnalytics: customDiscoverAnalyticsInfo,
                    ai_tracking: aiTrackingInfo,
                    additional_seats: additional_seats ?? {},
                    content_analysis: contentAnalysis ?? {},
                };
            }

            this.setState({ billingInfo: info, geo_locations, informationLoading: false });

            if (this.props.updateBillingInfo) this.props.updateBillingInfo(info);
        } catch (err) {
            showMessage(err.message ?? 'Error fetching information.', 'error');
            this.setState({ informationLoading: false });
        }
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.defaultData) !== JSON.stringify(this.props.defaultData)) {
            const products = { ...this.state.products };
            const defaultProducts = { ...this.state.products };
            const addOns = { ...this.state.addOns };

            if (
                this.props.defaultData?.ai_tracking ||
                this.props.inactiveProduct === 'ai_tracking'
            ) {
                products.ai_tracking = this.products ? this.products.includes('ai_tracking') : true;
                products.ai_tracking_prompts = this.ai_tracking_prompts
                    ? Math.ceil(this.ai_tracking_prompts / 10) * 10
                    : this.props.defaultData.ai_tracking?.quantity ?? 100;

                defaultProducts.ai_tracking = true;
                defaultProducts.ai_tracking_prompts =
                    this.props.defaultData.ai_tracking?.quantity ?? 100;
            } else {
                products.ai_tracking = this.products
                    ? this.products.includes('ai_tracking')
                    : false;
                defaultProducts.ai_tracking = false;
            }

            if (
                this.props.defaultData?.discoverAnalytics ||
                this.props.inactiveProduct === 'google_discover_analytics'
            ) {
                products.google_discover_analytics = !this.products
                    ? true
                    : this.products.includes('google_discover_analytics');
                products.google_analytics_domains = this.domainsQuantity
                    ? Number(this.domainsQuantity)
                    : this.props.defaultData.discoverAnalytics?.quantity || 1;

                defaultProducts.google_discover_analytics = true;
                defaultProducts.google_analytics_domains =
                    this.props.defaultData.discoverAnalytics?.quantity || 1;
            } else {
                products.google_discover_analytics = !this.products
                    ? false
                    : this.products.includes('google_discover_analytics');
                defaultProducts.google_discover_analytics = false;
            }

            if (
                this.props.defaultData?.searchAnalytics ||
                this.props.inactiveProduct === 'google_search_analytics'
            ) {
                products.google_search_analytics = !this.products
                    ? true
                    : this.products.includes('google_search_analytics');
                products.google_analytics_domains = this.domainsQuantity
                    ? Number(this.domainsQuantity)
                    : this.props.defaultData.searchAnalytics?.quantity || 1;

                defaultProducts.google_search_analytics = true;
                defaultProducts.google_analytics_domains =
                    this.props.defaultData.searchAnalytics?.quantity || 1;
            } else {
                products.google_search_analytics = !this.products
                    ? false
                    : this.products.includes('google_search_analytics');
                defaultProducts.google_search_analytics = false;
            }

            if (this.props.defaultData?.commerce || this.props.inactiveProduct === 'commerce') {
                products.commerce = !this.products ? true : this.products.includes('commerce');
                defaultProducts.commerce = true;
            } else {
                products.commerce = !this.products ? false : this.products.includes('commerce');
                defaultProducts.commerce = false;
            }

            if (this.props.defaultData?.additional_seats) {
                addOns.additionalSeats = this.props.defaultData.additional_seats?.quantity || 0;
            } else {
                addOns.additionalSeats = 0;
            }
            if (this.props.defaultData?.content_analysis) {
                addOns.contentAnalysis = this.props.defaultData.content_analysis?.quantity || 0;
            } else {
                addOns.contentAnalysis = 0;
            }

            let interval = this.state.interval;

            switch (this.props.defaultInterval) {
                case 1: {
                    interval = 'monthly';
                    break;
                }
                case 3: {
                    interval = 'quarterly';
                    break;
                }
                case 12: {
                    interval = 'annualy';
                    break;
                }
                default: {
                    interval = 'monthly';
                }
            }

            if (this.props.inactiveProduct) {
                delete defaultProducts[this.props.inactiveProduct];
            }

            const defaultPriceIds = [];
            for (let key in this.props.defaultData) {
                const item = this.props.defaultData[key];
                defaultPriceIds.push({
                    price_id: item.price_id,
                    quantity: item.quantity,
                });
            }

            this.setState({
                products: this.isFreeAiTemplate ? { ...products, ai_tracking: true } : products,
                defaultProducts,
                interval,
                defaultInterval: interval,
                addOns,
                priceIds: {},
                defaultPriceIds,
                defaultAddOns: addOns,
                defaultPromotionCode: this.props.defaultPromotionCode || null,
            });
        }
    }

    onChangeInterval(interval) {
        this.setState({ interval });
        this.url = new URL(window.location);
        this.url.searchParams.set('interval', interval);
        history.pushState({}, '', this.url);
    }

    onApplyBundleDiscount() {
        const url = new URL(window.location.href);
        url.searchParams.set('promo_code', 'bundle20');
        window.history.pushState({}, '', url);
        this.onChangeProducts('google_discover_analytics', true, true);
        this.onChangeProducts('google_search_analytics', true, true);
    }

    maybeApplyBundleDiscount(products) {
        if (!products.google_discover_analytics || !products.google_search_analytics) return;

        if (this.state.promotion_code_info?.percent_off >= 20) return;

        const url = new URL(window.location.href);
        if (url.searchParams.get('promo_code') === 'bundle20') return;

        url.searchParams.set('promo_code', 'bundle20');
        window.history.pushState({}, '', url);
    }

    onChangeProducts(product, value, isToggle) {
        if (isToggle && !value) {
            this.setState((prevState) => {
                delete prevState.priceIds?.[product];
                return { priceIds: prevState.priceIds };
            });
        }

        this.maybeApplyBundleDiscount({ ...this.state.products, [product]: value });

        this.setState((prev) => ({ ...prev, products: { ...prev.products, [product]: value } }));
    }

    deleteItemFromPriceIds(key) {
        this.setState((prevState) => {
            delete prevState.priceIds?.[key];
            return { priceIds: prevState.priceIds };
        });
    }

    onChangeCustomPlan(key, value) {
        this.setState({ custom_plan: { ...this.state.custom_plan, [key]: value } });
    }

    onChangeUserInfo(key, value) {
        this.setState({ userInfo: { ...this.state.userInfo, [key]: value } });
    }

    onShowRegistration = (value) => {
        this.setState({ showRegistration: value });
    };

    deleteMessage() {
        this.setState({ message: '' });
    }

    updatePaymentMethodId(payment_method_id) {
        this.setState((prevState) => ({
            userInfo: { ...prevState.userInfo, payment_method_id },
        }));
    }

    updatePromoCodeInfo(promotion_code_info) {
        this.setState((prevState) => ({
            ...prevState,
            promotion_code_info,
        }));
    }

    deletePromoCodeInfo() {
        this.setState((prevState) => ({
            ...prevState,
            promotion_code_info: null,
        }));
    }

    checkIsChanged() {
        if (this.props.isEdit) {
            if (
                JSON.stringify(this.state.products) ===
                    JSON.stringify(this.state.defaultProducts) &&
                JSON.stringify(this.state.addOns) === JSON.stringify(this.state.defaultAddOns) &&
                this.state.defaultPromotionCode ===
                    (this.state.promotion_code_info?.promotion_code_id || null)
            ) {
                return true;
            }
        }
        return false;
    }

    async createRequestBody({ payment_method }) {
        try {
            if (this.state.priceIds?.additional_seats) delete this.state.priceIds?.additional_seats;
            if (this.state.priceIds?.content_analysis) delete this.state.priceIds?.content_analysis;

            const body = {
                email: this.state.userInfo.email,
                full_name: this.state.userInfo.name,
                password: this.state.userInfo.password,
                payment_method: payment_method || null,
                price_items: Object.values(this.state.priceIds),
                org: this.state.userInfo.organization,
                geo_location: this.state.userInfo.geo_location || null,
                promotion_code: this.state.userInfo.promotion_code || null,
            };

            const response = await createUser(body);
            const data = await response.json();
            if (response?.status >= 300) {
                this.setState({ message: data.message || data?.detail || 'Something went wrong' });
                return { status: 'error' };
            }
            window.location.href = '/customers/onboarding/';
            return { status: 'success' };
        } catch (err) {
            console.log('Error creating request body:', err);
        }
    }

    normalizePriceIds(priceIds) {
        let newPriceIds = {};
        for (let key in priceIds) {
            if (key === 'google_discover_analytics') {
                newPriceIds['discoverAnalytics'] = priceIds[key];
            } else if (key === 'google_search_analytics') {
                newPriceIds['searchAnalytics'] = priceIds[key];
            } else {
                newPriceIds[key] = priceIds[key];
            }
        }
        return newPriceIds;
    }

    checkDeactivatedOne() {
        const defaultData = this.props.defaultData;
        const newData = this.normalizePriceIds(this.state.priceIds);

        const missingOnes = [];

        Object.keys(defaultData).forEach((item) => {
            if (!newData[item]) {
                const data = {
                    price_id: defaultData[item].price_id,
                    quantity: 0,
                };
                missingOnes.push(data);
            }
        });
        return missingOnes;
    }

    async updateSubscription() {
        try {
            const price_items = Object.values(this.state.priceIds);
            const onlyProducts = {};
            for (let key in this.state.priceIds) {
                if (
                    key === 'ai_tracking' ||
                    key === 'google_discover_analytics' ||
                    key === 'google_search_analytics' ||
                    key === 'commerce'
                ) {
                    onlyProducts[key] = this.state.priceIds[key];
                }
            }

            if (Object.values(onlyProducts).length === 0) {
                this.onOpenCancelConfirmationModal();
                return;
            }

            const missingOnes = this.checkDeactivatedOne();

            const final_price_items = [...price_items, ...missingOnes];
            this.setState({ updateLoading: true });
            const body = {
                price_items: final_price_items,
                promotion_code: this.state.userInfo.promotion_code || null,
                payment_method_id: this.state.userInfo.payment_method_id || null,
            };

            if (this.props.isEdit && this.isFreeAiTemplate) {
                body.with_free_ai_tracking = true;
            }

            const response = await updateSubscriptionApi(body);
            const data = await response.json();
            if (response.ok) {
                showMessage('Subscription updated successfully.', 'success');
                window.localStorage.removeItem('userData');
                window.location.href = '/';
            } else {
                this.setState({ updateLoading: false });
                showMessage(
                    data.message || data?.detail || 'Error updating subscription.',
                    'error',
                );
            }
        } catch (err) {
            showMessage(err.message ?? 'Error updating subscription.', 'error');
            this.setState({ updateLoading: false });
        }
    }

    updateAddOns(key, value) {
        this.setState({
            addOns: {
                ...this.state.addOns,
                [key]: value,
            },
        });
    }

    render() {
        const { isEdit, isCancel, isReactivation } = this.props;

        // Add-ons are hidden while reactivating, so the steps after it move up by one.
        const showAddOns = isEdit && !isReactivation;
        const intervalStep = showAddOns ? 3 : 2;
        const cardStep = showAddOns ? 4 : 3;

        const isSelectedOneProduct = () => {
            const { products } = this.state;

            if (products.google_discover_analytics && !products.google_search_analytics)
                return true;
            if (!products.google_discover_analytics && products.google_search_analytics)
                return true;

            return false;
        };
        return (
            <>
                <div
                    className={`custom-registration ${
                        this.isFreeAiTemplate ? 'free-ai-template' : ''
                    }`}
                >
                    {(this.props.parentLoading || this.state.informationLoading) && (
                        <div className="custom-registration-loader">
                            <Loading />
                        </div>
                    )}
                    <>
                        {!isEdit && (
                            <div className="custom-registration-header">
                                <div className="custom-registration-header-logo">
                                    <img
                                        className="logo-symbol"
                                        src={
                                            this.isDark
                                                ? '/static/img/gddash_logo_dark.png'
                                                : '/static/img/gddash_logo1.png'
                                        }
                                        alt="logo"
                                    />
                                </div>
                                <div className="custom-registration-header-actions">
                                    <a className="sign-in-btn" href="/account/login/">
                                        Sign In
                                    </a>
                                </div>
                            </div>
                        )}
                        {this.state.already_registered && (
                            <div className="custom-registration-alert">
                                <MessageCustom
                                    message={this.state.already_registered_message}
                                    message_type="alert-danger"
                                    link="/account/login/"
                                    link_name="Sign In"
                                />
                            </div>
                        )}
                        {!isEdit && (
                            <div className="custom-registration-plan-info">
                                <div className="custom-registration-plan-info-description">
                                    {this.isFreeAiTemplate
                                        ? '30-day free AI Tracking'
                                        : 'Build a plan that fits your needs'}
                                </div>
                                <div className="custom-registration-plan-info-trial-pill">
                                    <span className="custom-registration-plan-info-trial-pill-icon">
                                        🎁
                                    </span>
                                    {this.isFreeAiTemplate ? (
                                        <span>
                                            Try AI Tracking free for 30 days. <b>Cancel anytime.</b>
                                        </span>
                                    ) : (
                                        <span>
                                            <b>14-day free trial</b> For new users and new domains •
                                            Cancel anytime
                                        </span>
                                    )}
                                </div>
                            </div>
                        )}
                        <div className="custom-registration-body">
                            <Products
                                onChangeProducts={this.onChangeProducts}
                                products={this.state.products}
                                isAiTemplate={this.isAiTemplate}
                                defaultData={this.props.defaultData}
                                isEdit={isEdit}
                                billingInfo={this.state.billingInfo}
                                interval={this.state.interval}
                                isFreeAiTemplate={this.isFreeAiTemplate}
                            />
                            {isSelectedOneProduct() &&
                                (!this.state.promotion_code_info ||
                                    !this.state.promotion_code_info?.percent_off ||
                                    this.state.promotion_code_info?.percent_off < 20) && (
                                    <div className="custom-registration-bundle-discount">
                                        <div className="custom-registration-bundle-discount-icon">
                                            <img src="/static/img/Offer.svg" alt="discount" />
                                        </div>
                                        <div className="custom-registration-bundle-discount-content">
                                            <div className="custom-registration-bundle-discount-content-title">
                                                Get 20% off forever when you get both Search
                                                Analytics, and Discover Analytics
                                            </div>
                                        </div>
                                        <button
                                            className="custom-registration-bundle-discount-btn"
                                            onClick={this.onApplyBundleDiscount}
                                        >
                                            Apply Discount
                                        </button>
                                    </div>
                                )}
                            {showAddOns && (
                                <AddOns
                                    contentAnalysis={this.state.addOns.contentAnalysis}
                                    additionalSeats={this.state.addOns.additionalSeats}
                                    updateAddOns={this.updateAddOns}
                                    billingInfo={this.state.billingInfo}
                                    defaultAddOns={this.state.defaultAddOns}
                                    interval={this.state.interval}
                                />
                            )}
                            <Interval
                                step={intervalStep}
                                isEdit={isEdit}
                                custom_plan={this.state.custom_plan}
                                onChangeCustomPlan={this.onChangeCustomPlan}
                                onShowRegistration={this.onShowRegistration}
                                interval={this.state.interval}
                                onChangeInterval={this.onChangeInterval}
                                products={this.state.products}
                                defaultProducts={this.state.defaultProducts}
                                billingInfo={this.state.billingInfo}
                                updatePrices={this.updatePrices}
                                onChangeUserInfo={this.onChangeUserInfo}
                                priceIds={this.state.priceIds}
                                updateLastPrice={this.updateLastPrice}
                                updatePromoCodeInfo={this.updatePromoCodeInfo}
                                addOns={this.state.addOns}
                                defaultInterval={this.state.defaultInterval}
                                defaultPromotionCode={this.state.defaultPromotionCode}
                                inactiveProduct={this.props.inactiveProduct}
                                defaultPriceIds={this.state.defaultPriceIds}
                                deleteItemFromPriceIds={this.deleteItemFromPriceIds}
                                deletePromoCodeInfo={this.deletePromoCodeInfo}
                                isFreeAiTemplate={this.isFreeAiTemplate}
                            />
                            {isEdit && (
                                <EditCard
                                    step={cardStep}
                                    payment_methods={this.props.payment_methods}
                                    updatePaymentMethodId={this.updatePaymentMethodId}
                                />
                            )}
                            {!isEdit && (
                                <UserInformation
                                    onChangeUserInfo={this.onChangeUserInfo}
                                    isSubmitDissabled={
                                        !this.state.billingInfo?.discoverAnalytics &&
                                        !this.state.billingInfo?.searchAnalytics &&
                                        !this.state.billingInfo?.ai_tracking &&
                                        !this.state.billingInfo?.commerce
                                    }
                                    createRequestBody={this.createRequestBody}
                                    products={this.state.products}
                                    geo_locations={this.state.geo_locations}
                                    lastPrice={this.state.lastPrice}
                                    totalSavings={
                                        this.state.promotion_code_info?.total_savings_cents
                                    }
                                    isFreeAiTemplate={this.isFreeAiTemplate}
                                />
                            )}
                            {!isEdit && <Information isFreeAiTemplate={this.isFreeAiTemplate} />}
                            {!isEdit && <Questions />}
                            {isEdit && (
                                <div className="w-100">
                                    {window.user_permissions?.user_type === 'traditional' && (
                                        <div className="custom-registration-interval-warning mt-10 mb-10">
                                            Your account will be upgraded to our new plans, pricing
                                            might be different from your current plan.
                                        </div>
                                    )}
                                    <button
                                        className="registration-container-info-submit"
                                        type="button"
                                        onClick={this.updateSubscription}
                                        disabled={this.state.updateLoading || this.checkIsChanged()}
                                    >
                                        {this.state.updateLoading && <Loading onlyPreloader />}
                                        Update
                                    </button>
                                </div>
                            )}
                            {isCancel && <Cancelation />}
                            <CancelationByUnselectAll
                                isOpen={this.state.isCancelConfirmationModalOpen}
                                onClose={this.onCloseCancelConfirmationModal}
                            />
                        </div>
                    </>
                </div>
                {this.state.message && (
                    <div className="messages">
                        <Message
                            message_tags={'error'}
                            message={this.state.message}
                            deleteMessage={this.deleteMessage}
                        />
                    </div>
                )}
            </>
        );
    }
}

export default CustomRegistration;
